/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { InformativePaFasce } from "./InformativePaFasce";
import { InformativePaMaster } from "./InformativePaMaster";
import * as t from "io-ts";

// required attributes
const InformativePaDetailR = t.interface({});

// optional attributes
const InformativePaDetailO = t.partial({
  flagDisponibilita: t.boolean,

  giorno: t.string,

  id: t.Integer,

  tipo: t.string
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type InformativePaDetail = t.TypeOf<typeof InformativePaDetailR> &
  t.TypeOf<typeof InformativePaDetailO> & {
  readonly "fasce"?: ReadonlyArray<InformativePaFasce>;
  readonly "fkInformativaPaMaster"?: InformativePaMaster;
  };

export const InformativePaDetail: t.Type<InformativePaDetail> = t.recursion("InformativePaDetail", () =>
  t.intersection(
    [InformativePaDetailR, t.partial({ ...InformativePaDetailO.props, "fasce": t.readonlyArray(InformativePaFasce, "array of InformativePaFasce"), "fkInformativaPaMaster": InformativePaMaster })],
    "InformativePaDetail"
  ) as unknown as t.Type<InformativePaDetail>
);
